import React, { useState } from 'react';
import useGrid from '../hooks/useGrid';
import usePlants from '../hooks/usePlants';
import GridCell from './GridCell';
import './GridView.css';

function GridView({ onCellSelect, onPlantDrop }) {
  const { gridConfig, loading } = useGrid();
  const { getPlantsByCell } = usePlants();
  const [selectedCell, setSelectedCell] = useState(null);

  const handleCellClick = (row, col) => {
    setSelectedCell({ row, col });
    if (onCellSelect) {
      onCellSelect(row, col);
    }
  };

  if (loading) {
    return <div className="grid-view__loading">Loading grid...</div>;
  }

  const { rows, cols } = gridConfig;

  const renderColumnHeaders = () => {
    const headers = [<div key="corner" className="grid-view__header-corner" />];
    for (let col = 0; col < cols; col++) {
      headers.push(
        <div key={`col-${col}`} className="grid-view__col-header">
          {col + 1}
        </div>
      );
    }
    return headers;
  };

  const renderRows = () => {
    const rowElements = [];
    for (let row = 0; row < rows; row++) {
      rowElements.push(
        <div key={`row-header-${row}`} className="grid-view__row-header">
          {row + 1}
        </div>
      );
      for (let col = 0; col < cols; col++) {
        const plants = getPlantsByCell(row, col);
        const isSelected =
          selectedCell !== null &&
          selectedCell.row === row &&
          selectedCell.col === col;
        rowElements.push(
          <GridCell
            key={`cell-${row}-${col}`}
            row={row}
            col={col}
            plantCount={plants.length}
            selected={isSelected}
            onClick={handleCellClick}
            onDrop={onPlantDrop}
          />
        );
      }
    }
    return rowElements;
  };

  return (
    <div className="grid-view">
      <div
        className="grid-view__grid"
        style={{
          gridTemplateColumns: `auto repeat(${cols}, 1fr)`,
          gridTemplateRows: `auto repeat(${rows}, 1fr)`,
        }}
      >
        {renderColumnHeaders()}
        {renderRows()}
      </div>
    </div>
  );
}

export default GridView;
